import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  DisablePointerEvents,
  DropZoneDisabled,
  DropZoneEnabled,
  EnablePointerEvents,
  FileToUploadChanged,
  InsertTickets,
  NotificationEmailChanged,
  PanelStatusChanged,
  TicketAssigneeChanged,
  TicketCategoryChanged,
  TicketCountryChanged,
  TicketLSChanged,
  TicketSeverityChanged,
  TicketStatusChanged,
} from '../actions/mass-insertion.actions';
import { MassInsertionState } from '../models/tickets.models';

const initialState: MassInsertionState = {
  panelExpanded: true,
  ticketSeverity: 0,
  loyaltySchema: 0,
  ticketStatus: 0,
  country: 0,
  ticketCategory: 0,
  ticketAssignee: 0,
  dropZone: false,
  pointerEvents: false,
  fileName: '',
  file: {},
  notificationEmail: '',
  submit: false,
};

export const MassInsertionReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(TicketLSChanged, (state, { loyaltySchema }) => ({
    ...state,
    loyaltySchema,
  })),
  on(TicketStatusChanged, (state, { ticketStatus }) => ({
    ...state,
    ticketStatus,
  })),
  on(TicketCountryChanged, (state, { country }) => ({
    ...state,
    country,
  })),
  on(TicketCategoryChanged, (state, { ticketCategory }) => ({
    ...state,
    ticketCategory,
  })),
  on(TicketAssigneeChanged, (state, { ticketAssignee }) => ({
    ...state,
    ticketAssignee,
  })),
  on(TicketSeverityChanged, (state, { ticketSeverity }) => ({
    ...state,
    ticketSeverity,
  })),
  on(DropZoneEnabled, (state) => ({
    ...state,
    dropZone: true,
  })),
  on(DropZoneDisabled, (state) => ({
    ...state,
    dropZone: false,
    pointerEvents: false,
  })),
  on(EnablePointerEvents, (state) => ({
    ...state,
    pointerEvents: true,
  })),
  on(DisablePointerEvents, (state) => ({
    ...state,
    pointerEvents: false,
  })),
  on(FileToUploadChanged, (state, { file }) => ({
    ...state,
    file,
    fileName: file.name ?? '',
  })),
  on(NotificationEmailChanged, (state, { notificationEmail }) => ({
    ...state,
    notificationEmail,
  })),
  on(InsertTickets, (state) => ({
    ...state,
    submit: true,
  })),
  on(ActiveComponentChanged, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
